/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Campaigns_Mag7_Fine_Print_EligibilityInputs */

const en_campaigns_mag7_fine_print_eligibility = /** @type {(inputs: Campaigns_Mag7_Fine_Print_EligibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rewards go only to holders of the portfolio linked above, not to other portfolios.`)
};

const de_campaigns_mag7_fine_print_eligibility = /** @type {(inputs: Campaigns_Mag7_Fine_Print_EligibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prämien erhalten nur Inhaber des oben verlinkten Portfolios, nicht Inhaber anderer Portfolios.`)
};

const pt_br2_campaigns_mag7_fine_print_eligibility = /** @type {(inputs: Campaigns_Mag7_Fine_Print_EligibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As recompensas são exclusivas para quem mantém o portfólio indicado acima e não se aplicam a outros portfólios.`)
};

const tr_campaigns_mag7_fine_print_eligibility = /** @type {(inputs: Campaigns_Mag7_Fine_Print_EligibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödüller yalnızca yukarıda bağlantısı verilen portföyü elinde tutanlara verilir; diğer portföyler kapsam dışıdır.`)
};

const zh_cn2_campaigns_mag7_fine_print_eligibility = /** @type {(inputs: Campaigns_Mag7_Fine_Print_EligibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`奖励仅面向持有上述关联投资组合的用户，其他投资组合不适用。`)
};

const zh_hk2_campaigns_mag7_fine_print_eligibility = /** @type {(inputs: Campaigns_Mag7_Fine_Print_EligibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`獎賞只發放予持有上方所連結投資組合的用戶，並不適用於其他投資組合。`)
};

const ko_kr2_campaigns_mag7_fine_print_eligibility = /** @type {(inputs: Campaigns_Mag7_Fine_Print_EligibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`리워드는 위에 연결된 포트폴리오 보유자에게만 지급되며, 다른 포트폴리오에는 적용되지 않습니다.`)
};

const ru_ru2_campaigns_mag7_fine_print_eligibility = /** @type {(inputs: Campaigns_Mag7_Fine_Print_EligibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вознаграждения получают только держатели портфеля по ссылке выше, но не других портфелей.`)
};

const es_419_campaigns_mag7_fine_print_eligibility = /** @type {(inputs: Campaigns_Mag7_Fine_Print_EligibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las recompensas son solo para quienes mantienen el portafolio vinculado arriba, no para otros portafolios.`)
};

/**
* | output |
* | --- |
* | "Rewards go only to holders of the portfolio linked above, not to other portfolios." |
*
* @param {Campaigns_Mag7_Fine_Print_EligibilityInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const campaigns_mag7_fine_print_eligibility = /** @type {((inputs?: Campaigns_Mag7_Fine_Print_EligibilityInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Campaigns_Mag7_Fine_Print_EligibilityInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_campaigns_mag7_fine_print_eligibility(inputs)
	if (locale === "de") return de_campaigns_mag7_fine_print_eligibility(inputs)
	if (locale === "pt-BR") return pt_br2_campaigns_mag7_fine_print_eligibility(inputs)
	if (locale === "tr") return tr_campaigns_mag7_fine_print_eligibility(inputs)
	if (locale === "zh-CN") return zh_cn2_campaigns_mag7_fine_print_eligibility(inputs)
	if (locale === "zh-HK") return zh_hk2_campaigns_mag7_fine_print_eligibility(inputs)
	if (locale === "ko-KR") return ko_kr2_campaigns_mag7_fine_print_eligibility(inputs)
	if (locale === "ru-RU") return ru_ru2_campaigns_mag7_fine_print_eligibility(inputs)
	return es_419_campaigns_mag7_fine_print_eligibility(inputs)
});